export class Dawa {
  text!: string;
  address!: Address;
}

export class Address {
  id!: string;
  status!: number;
  darstatus!: number;
  roadCode!: string;
  streetName!: string;
  addressingStreetName!: string;
  country!: string;
  houseNumber!: string;
  floor?: string;
  door?: string;
  additionalStreetName!: string;
  postnr!: string;
  postalName!: string;
  mainRecipientRecordNumber!: string;
  majorRecipientRecordName!: string;
  municipalCode!: string;
  accessAddress!: string;
  x!: number;
  y!: number;
  href!: string;
  litra?:string;
}
